/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Tasks_View_TableInputs */

const en_my_tasks_view_table = /** @type {(inputs: My_Tasks_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table view`)
};

const pt_br2_my_tasks_view_table = /** @type {(inputs: My_Tasks_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização em tabela`)
};

/**
* | output |
* | --- |
* | "Table view" |
*
* @param {My_Tasks_View_TableInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const my_tasks_view_table = /** @type {((inputs?: My_Tasks_View_TableInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Tasks_View_TableInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_tasks_view_table(inputs)
	return pt_br2_my_tasks_view_table(inputs)
});